import { useQuery } from '@tanstack/react-query'
import { getCategories } from 'api-client/lib/routes/taas'

export function useTaasCategories() {
  return useQuery(['taas-categories'], () => getCategories())
}
